import { Api } from "common-components";

/**
 * 獲取科目維護頁面資料
 */
export const getTransactionLog = async () => {
	const response = await Api.get(`${process.env.REACT_APP_RESOURCE_PLATFORM_DOMAIN}/api/Transaction`);
	return response;
};
